import dark from './dark/index.mjs';
var Themes = {
  dark
};
export var _ThemesComponent = null;
export default Themes;